import React, { useState } from 'react';
import Contact from './components/contact/Contact';
import Experience from './components/experience/Experience';
import Footer from './components/footer/Footer';
import Header from './components/header/Header';
import Header1 from './components/header1/Header1';
import Intro from './components/intro/Intro';
import Intro1 from './components/intro/Intro1';
import Portfolio from './components/portfolio/Portfolio';
import Top from './components/Top/Top';
import Topbar from './components/topbar/Topbar';
import { LiquidLoader   } from 'react-loaders-kit';
import { useEffect } from 'react';

import ring from "./assets/loading-79.gif"
import "./app.css"
const App = () => {
    const [loading, setLoading] = useState(false);


  //   const loaderProps = {
  //     loading,
  //     size: 35,
  //     duration: 2,
  //     color: '#6b6767'
  // }

    useEffect(()=>{
      setLoading(true);
      setTimeout(()=>{
        setLoading(false)
      },1500)
    },[])
  return (
    <>
    {/* {loading ? <LiquidLoader  {...loaderProps}/>:  */}
    {/* {loading ? <img style={{display: "block", marginLeft: "auto", marginRight: "auto",width:"50%",backgroundColor:"white"}} src={ring} alt=''/>:  */}
    {loading ? 
      <div id='bag' style={{backgroundColor:'#ffffff',width:"100%",height:"100vh",margin:"auto"}}>
        <img id='load' style={{width:"60%",height:"100%",margin:"auto"}} src={ring} alt="" />
      </div>
    : 
    <div>
      <Top/>
      <Header1 />
      <Topbar />
      <Intro1 />
      <Experience />
      <Portfolio />
      <Contact />
      <Footer />
      </div>
  }
    </>
  )
}

export default App
